import { addLateReadingCall } from "api/api";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useEffect, useState } from "react";
import Modal from "../../components/modal";

export default function LateReadingCreatePopup({ setOpen, open }) {
  const onSubmit = async () => {
    const response = await addLateReadingCall({
      late_reading_date: state.late_reading_date,
    });
    if (response) {
      setOpen(false);
    }
  };

  const [state, setState] = useState({ late_reading_date: "" });

  useEffect(() => {
    if (open) {
      setState({ late_reading_date: "" });
    }
  }, [open]);

  return (
    <Modal
      title={"Late Readings"}
      open={open}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onSubmit} variant="gradient" color="info">
            submit
          </MDButton>
          <MDButton
            onClick={() => {
              setOpen(false);
            }}
            variant="gradient"
            color="error"
          >
            cancel
          </MDButton>
        </MDBox>
      }
    >
      <MDBox component="form" role="form">
        <MDBox mb={2}>
          <MDInput
            type="date"
            label="Late Reading Date"
            fullWidth
            value={state.late_reading_date}
            onChange={(event) => {
              setState({ ...state, late_reading_date: event.target.value });
            }}
          />
        </MDBox>
      </MDBox>
    </Modal>
  );
}
